import { ForbiddenTypes } from '@common/types/service';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ErrorState {
    status: number | null;
    case?: ForbiddenTypes;
}

const initialState: ErrorState = {
    status: null,
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setError: (
            state,
            { payload: { case: caseValue, status } }: PayloadAction<{ status: number | null; case?: ForbiddenTypes }>
        ) => {
            state.status = status;
            state.case = caseValue;
        },
    },
});

export const { setError } = errorSlice.actions;
export default errorSlice.reducer;
